import React from 'react'
import moment from 'moment';

// The "About" tab: everything a shopper wants to know about the shop.
export default function BusinessDashboard({ seller }) {
    const facts = [
        { icon: '📍', label: 'Location', value: [seller.address1, seller.city, seller.state].filter(Boolean).join(', ') },
        { icon: '📞', label: 'Phone', value: seller.ownerPhone },
        { icon: '🌐', label: 'Website', value: seller.website, link: seller.website },
        { icon: '🗂️', label: 'Category', value: seller.businessType },
        { icon: '🗓️', label: 'On BirrPlug since', value: seller.createdAt ? moment(seller.createdAt).format('MMMM YYYY') : null },
        { icon: '📦', label: 'Products listed', value: seller.products ? String(seller.products.length) : null },
    ].filter(f => f.value);

    return (
        <div className="bp-panel" style={{ padding: '26px' }}>
            <div className="bp-about-grid">
                <div className="bp-about-facts">
                    <h3>Shop details</h3>
                    {facts.map(f => (
                        <div className="bp-about-fact" key={f.label}>
                            <span className="bp-about-ico" aria-hidden="true">{f.icon}</span>
                            <div>
                                <small className="bp-dim">{f.label}</small>
                                {f.link
                                    ? <a href={f.link.startsWith('http') ? f.link : `https://${f.link}`} target="_blank" rel="noreferrer">{f.value} ↗</a>
                                    : <span>{f.value}</span>}
                            </div>
                        </div>
                    ))}
                </div>
                <div className="bp-about-story">
                    <h3>About this shop</h3>
                    <p>{seller.about || `${seller.businessName || 'This shop'} sells on BirrPlug — every order is settled on-chain, and payments in BRC go directly to the seller's wallet.`}</p>
                    {seller.note && (
                        <>
                            <h3>Good to know</h3>
                            <p>{seller.note}</p>
                        </>
                    )}
                    <div className="bp-about-trust">
                        <span className="bp-shop-chip">⛓ on-chain settlement</span>
                        <span className="bp-shop-chip">🔐 wallet-verified seller</span>
                    </div>
                </div>
            </div>
        </div>
    )
}
